import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModifierPromptsAssignmentModal } from './modifier-prompts-assignment.modal';
import { IonicModule } from '@ionic/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoSelectDirectiveModule } from 'src/app/directives/transloco-select/transloco-select.module';

@NgModule({
  declarations: [ModifierPromptsAssignmentModal],
  imports: [
    CommonModule,
    IonicModule,
    NgSelectModule,
    ReactiveFormsModule,
    TranslocoModule,
    TranslocoSelectDirectiveModule
  ],
  exports: [ModifierPromptsAssignmentModal]
})
export class ModifierPromptsAssignmentModalModule {}
